import { forwardRef, Fragment, useEffect, useImperativeHandle, useRef, useState } from "react";
import $ from "jquery";
import "select2";
import { isValidArray } from "../common";
import Select2Dropdown from "./Select2DropDown";
import { faAlignJustify } from "@fortawesome/free-solid-svg-icons";
export const FilterPopup = forwardRef(({ callbackFunction, handleFilterProduct, clearFilter, filterItems }, ref) => {
  const [selectedValues, setSelectedValues] = useState([]);
  const [catFilter, setCatFilter] = useState([]);
  const [brandfilter, setBrandfilter] = useState(null);
  const [modelFilter, setModelFilter] = useState(null);
  const [attributeFilter, setAttributeFilter] = useState(null);
  const [categoryFilter, setCategoryFilter] = useState(null);
  const [brandOption, setBrandOption] = useState(null);
  const [modelOption, setModelOption] = useState(null);
  const [searchTerms, setSearchTerms] = useState({});
  const [expandedFilters, setExpandedFilters] = useState({});

  useEffect(() => {
    if (filterItems) {
      setAttributeFilter(filterItems);
    }
  }, [filterItems]);

  useEffect(() => {
    var filterLength = Object.values(selectedValues).reduce((sum, currentArray) => sum + currentArray.length, 0);
    callbackFunction(filterLength);
    handleFilterProduct(selectedValues);
  }, [catFilter, brandfilter, modelFilter, selectedValues]);

  useImperativeHandle(ref, () => ({
    clearfilter,
  }));

  const clearfilter = () => {
    setSelectedValues([]);
  };

  const handleSelectChange = (dropdownName, selectedValue) => {
    setSelectedValues((prev) => {
      const updatedValues = { ...prev };
      if (selectedValue && selectedValue.length > 0) {
        updatedValues[dropdownName] = selectedValue;
      } else {
        delete updatedValues[dropdownName];
      }
      return updatedValues;
    });
  };

  const handleRemoveItem = (key, value) => {
    setSelectedValues((prevData) => {
      const updatedValues = prevData[key].filter((item) => item != value);
      const updatedData = { ...prevData, [key]: updatedValues };
      if (updatedValues.length == 0) {
        delete updatedData[key];
      }
      return updatedData;
    });
  };

  const handleBrandChangeFilter = (val) => {
    handleSelectChange("Brand", [val]);
  };
  const handleModelChangeFilter = (val) => {
    handleSelectChange("Model", [val]);
  };

  const handleCategoryChange = (key, e) => {
    const { value, checked } = e.target;
    let arrayObject;
    if (checked) {
      arrayObject = [...(selectedValues[key] || []), value];
    } else {
      arrayObject = selectedValues[key].filter((item) => item != value);
    }
    handleSelectChange(key, arrayObject);
  };
  const handleSearch = (index, value) => {
    setSearchTerms((prev) => ({
      ...prev,
      [index]: value,
    }));
  };
  const toggleExpand = (index) => {
    setExpandedFilters((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };
  return (
    <Fragment>
      {isValidArray(brandOption) && isValidArray(modelOption) && false && (
        <div className="dropdown productFiltersList">
          <button
            className="btn dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            data-bs-auto-close="outside"
            aria-expanded="false"
          >
            <p>
              {" "}
              What Fits My Device
              <span>
                <span className="productFilter-title"> Select your device brand and model</span>
              </span>
              <i className="fa-solid fa-chevron-down"></i>
            </p>
          </button>

          <div className="dropdown-menu productsFilter-dropdown">
            <div className="filterBody-content">
              {/* Select a Brand */}
              <Select2Dropdown
                options={brandOption}
                onChange={handleBrandChangeFilter}
                placeholder={"Select a brand"}
                caption="Select a Brand"
              />
              <Select2Dropdown
                options={modelOption}
                onChange={handleModelChangeFilter}
                placeholder={"Select a model"}
                caption="Select a Model"
              />

              {/* Select a Brand */}
            </div>
          </div>
        </div>
      )}
      {isValidArray(categoryFilter) && (
        <div className="dropdown productFiltersList">
          <button
            className="btn dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            data-bs-auto-close="outside"
            aria-expanded="false"
          >
            <p>
              <span>
                <span className="productFilter-title"> Category</span>
                {isValidArray(selectedValues["Category"]) && (
                  <small className="selected-filterCount">{selectedValues["Category"].length}</small>
                )}
              </span>
              <i className="fa-solid fa-chevron-down"></i>
            </p>
          </button>

          <div className="dropdown-menu productsFilter-dropdown" aria-labelledby="categoryDropdown">
            <div className="productFilter-search mb-3">
              <input className="form-control" type="search" placeholder="Search Category" aria-label="Search" />
            </div>

            <div className="productsItems-listing">
              {(expandedFilters["Category"] ? categoryFilter : categoryFilter.slice(0, 7)).map((item, index) => (
                <div className="productsItems-selection" key={item.id || index}>
                  <div className="common-checkbox-selection">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="productCategory"
                      value={item.label}
                      id={item.id}
                      onChange={(e) => handleCategoryChange("Category", e)}
                      checked={selectedValues["Category"] && selectedValues["Category"].includes(item.label)}
                    />
                  </div>
                  <label className="form-check-label" htmlFor={item.id || `productCategory_${index}`}>
                    {item.label}
                    <span>({item.count})</span>
                  </label>
                </div>
              ))}
            </div>
            <div className="productsitems-collapse">
              {categoryFilter.length > 7 && (
                <a className="collapseFilterBtn" onClick={() => toggleExpand("Category")}>
                  {expandedFilters["Category"] ? "Show Less" : "Show All"} Category
                </a>
              )}
            </div>
          </div>
        </div>
      )}

      {isValidArray(attributeFilter) &&
        attributeFilter.map((row, index) => {
          const searchValue = searchTerms[index] ? searchTerms[index].toLowerCase() : "";

          const filteredValues = isValidArray(row.attributeValues)
            ? row.attributeValues.filter((item) => item.value.toLowerCase().includes(searchValue))
            : [];
          return (
            <div className="dropdown productFiltersList" key={index}>
              <button
                className="btn dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-expanded="false"
              >
                <p>
                  <span>
                    <span className="productFilter-title"> {row.attributeName}</span>
                    {isValidArray(selectedValues[row.attributeName]) && (
                      <small className="selected-filterCount">{selectedValues[row.attributeName].length}</small>
                    )}
                  </span>
                  <i className="fa-solid fa-chevron-down"></i>
                </p>
              </button>

              <div className="dropdown-menu productsFilter-dropdown" aria-labelledby="categoryDropdown">
                <div className="productFilter-search mb-3">
                  <input
                    className="form-control"
                    type="search"
                    placeholder={`Search ${row.attributeName}`}
                    value={searchTerms[index] || ""}
                    onChange={(e) => handleSearch(index, e.target.value)}
                  />
                </div>

                <div className="productsItems-listing">
                  {filteredValues.length > 0 ? (
                    (expandedFilters[index] || true ? filteredValues : filteredValues.slice(0, 7)).map(
                      (item, insideindex) => (
                        <div className={`productsItems-selection ${item.disabled === 1 ? "disabled" : ""}`}>
                          <div className="common-checkbox-selection">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name={row.attributeName}
                              value={item.value}
                              id={row.attributeName + item.value}
                              checked={
                                selectedValues[row.attributeName] &&
                                selectedValues[row.attributeName].includes(item.value)
                              }
                              disabled={item.disabled == 1}
                              onChange={(e) => handleCategoryChange(row.attributeName, e)}
                            />
                          </div>
                          <label className="form-check-label" for={row.attributeName + item.value}>
                            {["color", "colour"].includes(row.attributeName.toLowerCase()) && (
                              <ColorValue color={item.value} />
                            )}
                            {item.value} {/*<span>({item.count})</span> */}
                          </label>
                        </div>
                      ),
                    )
                  ) : (
                    <p className="text-muted px-3">No matching results</p>
                  )}
                </div>
                <div className="productsItems-collapse">
                  {filteredValues.length > 7 && false && (
                    <a className="collapseFilterBtn" onClick={() => toggleExpand(index)}>
                      {expandedFilters[index] ? "Show Less" : "Show All"} {row.attributeName}
                    </a>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      {/* Filter List */}
    </Fragment>
  );
});

const ColorValue = ({ color }) => {
  const [hexValue, setHexValue] = useState(color);
  useEffect(() => {}, [color]);
  return <span className="product-color" style={{ backgroundColor: hexValue }}></span>;
};
